export const dict = {
	custom: {
		name: {
			required: "Please enter your name here",
			regex: "The name field format is invalid, this may contain alphabetic characters, numbers or underscores.",
		},
		label: {
			required: "Please enter your label here",
			alpha_spaces: "Your Lable may only contain alphabetic and spaces characters valid",
		},
	},
};
